(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product-recommendations-two"]) return;
  try {
    
$( document ).ready(function() {
$( "body" ).addClass( "modal-off" );
setTimeout(function(){
$( "body .prod-recom-two li" ).each(function( index ) {
$( this ).find( ".productitem--action-trigger" ).trigger( "click" );
});
}, 4000);
setTimeout(function(){
$( ".modal-loaded .modal" ).each(function( index ) {
$( ".modal-close" ).trigger( "click" );
});
$( "body" ).removeClass( "modal-off" );
}, 5000);
});

  } catch(e) { console.error(e); }
})();
})();
